import * as React from 'react';
import * as course from './style.module.scss';

export const Course = ({ descriptionText, hideDescText=false }) => {
  return (
    <section className={`${course.course} container`}>
      <div className={course.course__img}>
        <div className={course.course__imgDescription}>
          <p>
            <strong>
              {
                !hideDescText && ( descriptionText || "Для поддержания тонуса мозг нуждается в регулярных тренировках.")
              }
            </strong>
          </p>
          <p>Уже на первом занятии мы поделимся с&nbsp;вами приёмами эффективного запоминания, сохранения и&nbsp;воспроизведения
            информации.</p>
        </div>
      </div>
      <div className={course.course__elem}>
        <h2 className={course.course__title}>
          Наш курс для тех, кому хочется:
        </h2>
        <ul>
          <li className={course.course__item}>
            <p>
              Легко усваивать новую информацию
            </p>
          </li>
          <li className={course.course__item}>
            <p>
              Всегда держать свой мозг в тонусе
            </p>
          </li>
          <li className={course.course__item}>
            <p>
              Выучить иностранный язык
            </p>
          </li>
          <li className={course.course__item}>
            <p>
              Помнить всё до мелочей
            </p>
          </li>
        </ul>
      </div>
    </section>
  );
};
